import { Author } from "@customTypes/Author";
import { fetchApi } from "@utilities/fetchApi";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import { ProgrammeDetails } from "@customTypes/programmeDetails";
import clsx from "clsx";
import styles from "./C19.3.1_PromotionalFullWidth.module.scss";

export interface PromotionalFullWidthProps {
  withImage: boolean;
  reducedContent: boolean;
  tags?: Array<string>;
  itemsToShow?: number;
  author: Author;
  excludeArticle: boolean;
  excludeEvent: boolean;
  excludeNews: boolean;
}

const ArticleTile = dynamic(() =>
  import("@components/C19_20_Tiles/Tiles").then((mod) => mod.ArticleTile)
);

const EventTile = dynamic(() =>
  import("@components/C19_20_Tiles/Tiles").then((mod) => mod.EventTile)
);

const NewsTile = dynamic(() =>
  import("@components/C19_20_Tiles/Tiles").then((mod) => mod.NewsTile)
);

const tiles = {
  article: ArticleTile,
  event: EventTile,
  news: NewsTile,
};

const PromotionalRelatedFullWidth = ({
  content,
}: {
  content: PromotionalFullWidthProps;
}) => {
  const {
    withImage,
    reducedContent,
    tags,
    itemsToShow,
    author,
    excludeArticle,
    excludeEvent,
    excludeNews,
  } = content;
  const [items, setItems] = useState<ProgrammeDetails[]>([]);

  useEffect(() => {
    const payload: Record<string, unknown> = {};

    payload.tags = tags;
    if (author) {
      payload.author = author?.uid;
    }

    if (itemsToShow) {
      payload.limit = itemsToShow;
    }

    payload.excludeArticle = (!!excludeArticle)?.toString();
    payload.excludeEvent = (!!excludeEvent)?.toString();
    payload.excludeNews = (!!excludeNews)?.toString();

    const getData = async () => {
      const newsItems = await fetchApi(
        "/api/getNewsOrArticlesOrEvents",
        payload
      );
      setItems(newsItems);
    };

    getData();
  }, []);

  return (
    <div
      className={clsx(
        "component",
        styles["promotional-related-content"],
        itemsToShow === 2 && items.length === 2 && styles.two
      )}
    >
      <div className={clsx("wrapper", styles.wrapper)}>
        {items?.map((item, i) => {
          const Tile = tiles[item.type];
          const itemTags = item.contentfulMetadata?.tags || [];
          return (
            <Tile
              withImage={withImage}
              reducedContent={reducedContent}
              model={item}
              key={`${item.type}${i}`}
              tags={itemTags}
              customClass={clsx({[styles.halfWidth]:items.length === 2})}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PromotionalRelatedFullWidth;
